import { Route } from 'react-router-dom';
import PersonneMoraleDetails from './PersonneMoraleDetails';
import { personneMoraleSchema } from './personneMorale';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module PersonneMorale
 * Ces routes seront automatiquement intégrées au routeur principal
 */
const PersonneMoraleRoutes = [
    // Route de liste (principale)
    <Route
        key="personneMorales-list"
        path="personneMorales"
        element={
            <Main
                key="personneMorales-main"
                pageConfig={personneMoraleSchema}
            />
        }
    />,

    // Route de détail
    <Route
        key="personneMorales-detail"
        path="personneMorales/:id/details"
        element={<PersonneMoraleDetails />}
    />,
];

export default PersonneMoraleRoutes;
